var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-footer',{staticClass:"in-page-footer",class:`text-${_vm.textColor} bg-${_vm.backgroundColor}`,attrs:{"bordered":""}},[_c('div',{staticClass:"inner-wrapper"},[_c('q-toolbar',{staticClass:"q-pt-sm q-pr-lg q-pb-sm q-pl-lg q-gutter-sm items-right"},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }